import type { enums } from "@fraction/shared";
import { create } from "zustand";

interface ChatModalState {
  isOpen: boolean;
  applicationId?: string;
  chatType?: enums.ChatType;
  applicantNames?: string;
  applicationEid?: string;
  /** Floating, draggable window instead of the centered modal. Kept across opens. */
  compact: boolean;
  openChat: (
    applicationId: string,
    chatType: enums.ChatType,
    meta?: { applicantNames?: string; applicationEid?: string }
  ) => void;
  closeChat: () => void;
  toggleCompact: () => void;
}

export const useChatModalStore = create<ChatModalState>()((set) => ({
  isOpen: false,
  applicationId: undefined,
  chatType: undefined,
  applicantNames: undefined,
  applicationEid: undefined,
  compact: false,
  openChat: (applicationId, chatType, meta) =>
    set({
      isOpen: true,
      applicationId,
      chatType,
      applicantNames: meta?.applicantNames,
      applicationEid: meta?.applicationEid,
    }),
  closeChat: () =>
    set({
      isOpen: false,
      applicationId: undefined,
      chatType: undefined,
      applicantNames: undefined,
      applicationEid: undefined,
    }),
  toggleCompact: () => set((state) => ({ compact: !state.compact })),
}));
